import styled from 'styled-components';
import Box from '@rsos/components/capstone/base/Box';

export const SingleWrapper = styled(Box).attrs(() => ({
  pb: 3,
}))`
  width: 100%;
  position: relative;
  &:first-child {
    margin-top: 7px;
  }

  &:last-child {
    margin-bottom: 7px;
  }
`;

export const CircleAndLine = styled.div`
  margin-top: 2px;
  width: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding-right: 10px;
  height: 90%;
`;

// Notes: the circle was only introduced in historic location previously and now adding into
// Most Recent Location card, if we see this is being used across the app in future design, this
// should extend to take props of sizes
export const Circle = styled.div`
  width: 8px;
  height: 8px;
  background-color: ${({ theme, isCall }) =>
    isCall ? theme.colors.success : theme.colors.states};
  content: '';
  border-radius: 50%;
  top: 7px;
  margin-right: 0;
`;

export const Line = styled.div`
  width: 4px;
  background-color: ${({ theme, isCall }) =>
    isCall ? theme.colors.success : theme.colors.states};
  height: 70%;
  border-radius: 5px;
`;

export const InfoWrapper = styled.div`
  padding: 0 0 5px 0;
  margin-right: 5px;
  border-radius: 5px;
  text-overflow: ellipsis;
  width: 100%;
`;

export const SingleLocationWrapper = styled(Box).attrs(() => ({
  mt: '5px',
  width: '190px',
}))``;
